export default __webpack_public_path__ + "static/bench-975a3adf5827e148dcbaca590044fd78.png";